
import { useState } from 'react';
import { X, AlignLeft, AlignCenter, AlignRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Node } from '@xyflow/react';
import { NodeData } from './initial-nodes';

interface TextPropertiesPanelProps {
  node: Node<NodeData> | null;
  onClose: () => void;
  onSave: (nodeId: string, text: string, textAlign: 'left' | 'center' | 'right') => void;
}

export function TextPropertiesPanel({
  node,
  onClose,
  onSave,
}: TextPropertiesPanelProps) {
  const [text, setText] = useState(node?.data?.text || '');
  const [textAlign, setTextAlign] = useState<'left' | 'center' | 'right'>(
    (node?.data?.textAlign as 'left' | 'center' | 'right') || 'left'
  );

  if (!node) return null;

  const handleSave = () => {
    onSave(node.id, text, textAlign);
    onClose();
  };

  return (
    <div className="fixed top-0 right-0 w-80 h-full bg-white border-l border-gray-200 shadow-lg z-50 overflow-y-auto">
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold">Propriedades do Texto</h3>
        <Button variant="ghost" size="icon" onClick={onClose}>
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="p-4 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Texto
          </label>
          <Textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Digite o texto aqui..."
            rows={6}
            className="w-full"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Alinhamento do Texto
          </label>
          <div className="flex gap-2">
            <Button
              variant={textAlign === 'left' ? 'default' : 'outline'}
              size="icon"
              onClick={() => setTextAlign('left')}
              title="Alinhar à esquerda"
            >
              <AlignLeft className="h-4 w-4" />
            </Button>
            <Button
              variant={textAlign === 'center' ? 'default' : 'outline'}
              size="icon"
              onClick={() => setTextAlign('center')}
              title="Centralizar"
            >
              <AlignCenter className="h-4 w-4" />
            </Button>
            <Button
              variant={textAlign === 'right' ? 'default' : 'outline'}
              size="icon"
              onClick={() => setTextAlign('right')}
              title="Alinhar à direita"
            >
              <AlignRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
        
        <div className="flex justify-end gap-2 pt-4">
          <Button type="button" variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button 
            onClick={handleSave} 
            className="bg-[#05445e] hover:bg-[#189ab4]"
          >
            Salvar
          </Button>
        </div>
      </div>
    </div>
  );
}
